import React from 'react';
import { NavLink, Outlet, useOutletContext } from 'react-router-dom';
import { useIntl } from 'react-intl';
import { trpcSwr } from '../../../api/trpc';

export type OutletContextParams = {
  debouncedInternalId: string;
};

export const CustomsDeliveryOrdersDocumentsTab = () => {
  const intl = useIntl();
  const { debouncedInternalId } = useOutletContext<OutletContextParams>();

  const tabs = [
    {
      title: intl.formatMessage({
        id: 'customsDeliveries.tab-label.prepareDocs',
        defaultMessage: 'Подготовка документов',
        description: 'Надпись на вкладке',
      }),
      path: 'prepareDocs',
      name: 'prepareDocs' as const,
    },
    {
      title: intl.formatMessage({
        id: 'customsDeliveries.tab-label.declarant',
        defaultMessage: 'Декларант',
        description: 'Надпись на вкладке',
      }),
      path: 'declarant',
      name: 'declarant' as const,
    },
    {
      title: intl.formatMessage({
        id: 'customsDeliveries.tab-label.prepareInvoice',
        defaultMessage: 'Подготовить счет',
        description: 'Надпись на вкладке',
      }),
      path: 'prepareInvoice',
      name: 'prepareInvoice' as const,
    },
  ];

  const { data } = trpcSwr.customsDelivery.totalByStatus.useSWR({
    searchValue: debouncedInternalId,
  });

  const context: OutletContextParams = {
    debouncedInternalId: debouncedInternalId,
  };

  return (
    <>
      <ul className="nav nav-pills mb-4 d-inline-flex">
        {tabs.map((item) => (
          <li className="nav-item" key={item.title}>
            <NavLink to={item.path} className="nav-link text-decoration-none">
              {item.title} ({data ? data[item.name] || 0 : 0})
            </NavLink>
          </li>
        ))}
      </ul>

      <Outlet context={context} />
    </>
  );
};
